// extracted by mini-css-extract-plugin
module.exports = {"EmptySearchResults":"EmptySearchResults_EmptySearchResults__NmFFI","header":"EmptySearchResults_header__DavXv","message":"EmptySearchResults_message__vQKsq"};